import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=4da51661&"
import script from "./FileRow.vue?vue&type=script&lang=ts&"
export * from "./FileRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FileRow.vue"
export default component.exports